/* globals $ */
import envmap from '../../../../js/envmap.js'
import CustomSoundCloudPlayer from '../../../../js/player.js'
import svgcenter from '../../../../js/interface.js'

var textureDir = './images/textures/taa'
var soundCloudUrl = '/quinzequinze/sets/taa-poisson-volant/'
var playerSc = window.playerSc = new CustomSoundCloudPlayer(soundCloudUrl)

$(document).ready(function () {
  $(document.body).fadeIn(3000, function () {
    $(document.body).removeClass('hidden')
    svgcenter()
  })
})

envmap.create(textureDir)

playerSc.scplayer.on('scplayer.changing_track', function (e, index) {
  // this.scplayer.track_info(index).done(function (track) {
  //   console.log('la')
  //   if (typeof param !== 'undefined' && typeof envmap !== 'undefined') {
  //     envmap.setParams(param[index + 1])
  //   }
  // })
  this.current_track = index
}.bind(playerSc))

playerSc.scplayer.on('scplayer.changing_track', function (e, index) {
  $('[track]').attr('active', false)
  $('[track]').attr('idle', true)
  $('[track]').attr('track_name', false)
  var i = index + 1
  $('[track=' + i + ']').attr('active', true)
  $('[track=' + i + ']').attr('idle', false)
  $('[track=' + i + ']').attr('track_name', true)

  if (this !== null) {
    this.changeTexture(index)
  }
}.bind(envmap))
